import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/config/permit-types/')({
  beforeLoad: () => {
    throw redirect({ to: '/config/request-types', replace: true });
  },
});
